import { Component, OnInit, Input } from '@angular/core';
import { Location } from '@angular/common';
import { UtilityServiceService } from 'projects/services/src/app/API/utility-service.service';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';
import { CurrentUserService } from 'projects/services/src/app/current-user.service';
import { ShareDataService } from 'projects/shared/src/app/shared/share-data.service';
declare const swal: any;
@Component({
  selector: 'tp-feed-back-form',
  templateUrl: './tp-feed-back-form.component.html',
  styleUrls: ['./tp-feed-back-form.component.css']
})
export class TpFeedBackFormComponent implements OnInit {
  @Input() batchDetails: any;
  feedbackForm: FormGroup
  tpFeedbackForm: FormGroup
  questions: any = [];
  othersInput: boolean;
  QFourInput: boolean;
  isUpdate: boolean;
  loggedInUserName: any;
  role: any;
  hideForm: boolean;
  showLabel: boolean;
  constructor(
    private location: Location,
    private utilityService: UtilityServiceService,
    private fb: FormBuilder,
    private currentUserService: CurrentUserService,
    private sharedDataService: ShareDataService
  ) {
    this.tpFeedbackForm = this.fb.group({
			feedbacks: fb.array([])
    });
    this.currentUserService.getCurrentUser().subscribe(res => {
      this.loggedInUserName = res && res.userName;
      this.role = res && res.role;
    })


    if (this.batchDetails === undefined) {
      this.sharedDataService.getBatchDataForFeedbackForm().subscribe(batch => {
        this.batchDetails = batch;
      })
    }
    if (this.role === 'Continuous Monitoring' || this.role === 'Fee Based DA') {
      this.loggedInUserName = this.batchDetails && this.batchDetails.tpId;
    }
  }

  get candidate(): FormArray {
		return this.tpFeedbackForm.get('feedbacks') as FormArray;
  }




  createTpFeedbackForm(data) {
		return this.fb.group({
      feedback: this.fb.group({
        id: [data.id],
				question: [data.questionString],
        choice: [null, [Validators.required]],
        others: [],
			})
		});
	}
  ngOnInit() {
    this.feedbackForm = this.fb.group({
      feedback: this.fb.array([])
    })
    console.log(this.batchDetails)
    this.getQuestionsForCandidate();

  }

  getFeedback() {
    if (this.role === 'Training Partner') {
      this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'TPQSFY').subscribe(res => {
        console.log(res)
        const feedbackData = res && res.data && res.data.feedback || []
        if (feedbackData.length > 0) {
          this.isUpdate = true;
        }
        if (feedbackData.length > 0) {
          for (let index = 0; index < feedbackData.length; index++) {
            if (feedbackData[index].answer === null) {
              this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable();
              this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').setValidators([])
              this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').updateValueAndValidity([])
            }
            this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
            this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('others').patchValue(feedbackData[index].others);
          }
          if (this.tpFeedbackForm.get('feedbacks')['controls'][1].get('feedback').get('choice').value === 'Others') {
            this.othersInput = true;
          }
          if (this.tpFeedbackForm.get('feedbacks')['controls'][3].get('feedback').get('choice').value === 'Others') {
            this.QFourInput = true;
          }
        }


      })
    } else {
      this.utilityService.getFeedbackData(this.batchDetails.batchId, this.loggedInUserName, 'TPQSFY').subscribe(res => {
        console.log(res)
        const feedbackData = res && res.data && res.data.feedback || []
        if (feedbackData.length > 0) {
          this.isUpdate = true;
        } else {
          this.hideForm = true;
          this.showLabel = true;
        }


        if (feedbackData.length > 0) {
          for (let index = 0; index < feedbackData.length; index++) {
            this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').patchValue(feedbackData[index].answer);
            this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('choice').disable();

            this.tpFeedbackForm.get('feedbacks')['controls'][index].get('feedback').get('others').patchValue(feedbackData[index].others);
          }
          if (this.tpFeedbackForm.get('feedbacks')['controls'][1].get('feedback').get('choice').value === 'Others') {
            this.tpFeedbackForm.get('feedbacks')['controls'][1].get('feedback').get('others').disable()
            this.othersInput = true;
          }
          if (this.tpFeedbackForm.get('feedbacks')['controls'][3].get('feedback').get('choice').value === 'Others') {
            this.tpFeedbackForm.get('feedbacks')['controls'][3].get('feedback').get('others').disable()

            this.QFourInput = true;
          }

        }

      })
    }

  }


  createFeedbackForm(data): FormGroup {
    return this.fb.group({
      questions: data.questionString,
      answer: [],
      others: [],
    })
  }


  getQuestionsForCandidate() {
    this.utilityService.getMasterQuestion('TPQSFY').subscribe(res => {
      this.questions = res && res.data || [];
      console.log(this.questions)
      for (let index = 0; index < this.questions.length; index++) {
        // formInstance.push(this.createFeedbackForm(this.questions[index]))
        this.candidate.push(this.createTpFeedbackForm(this.questions[index]));

      }
      this.getFeedback()
    })
    console.log('FORM', this.feedbackForm)
  }

  sumitFeedback() {
    if (this.isUpdate) {
      swal({
        title: 'Are You Sure, You want to Update?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#d33',
      }).then((action: any) => {
        if (action.value) {
          this.utilityService.updateFeedback(this.batchDetails.batchId, this.loggedInUserName,'TPQSFY',this.mapPayload()).subscribe(res => {
            swal('Feedback Successfully Updated');
            this.goBack();
          })
        }
      })
    } else {
      swal({
        title: 'Are You Sure, You want to submit?',
        type: 'info',
        showCancelButton: true,
        cancelButtonText: 'Cancel',
        cancelButtonColor: '#d33',
      }).then((action: any) => {
        if (action.value) {
          this.utilityService.addFeedback(this.mapPayload()).subscribe(res => {
            swal('Feedback Successfully Submitted');
            this.goBack();
          })
        }
      })
    }


  }

  mapPayload() {
    const elements = (this.tpFeedbackForm.getRawValue().feedbacks) || [];
    const mapElements = elements.map(element => ({
      question: element && element.feedback && element.feedback.question,
      answer: element && element.feedback && element.feedback.choice,
      others: element && element.feedback && element.feedback.others
    }))
    const DATA = {
      tpName: this.batchDetails && this.batchDetails.tpName || '',
      tcName: this.batchDetails && this.batchDetails.tcName || '',
      tpId: this.batchDetails && this.batchDetails.tpId || '',
      tcId: this.batchDetails && this.batchDetails.tcId || '',
      qpCode: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].qpCode || '',
      jobRoleDesc: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobRoleDesc || '',
      jobName: this.batchDetails && this.batchDetails.jobRoles && this.batchDetails.jobRoles[0] && this.batchDetails.jobRoles[0].jobName || '',
      batchId: this.batchDetails && this.batchDetails.batchId,
      createdBy: this.loggedInUserName,
      type: 'TPQSFY',
      feedback: mapElements,

    }
    return DATA
  }
  goBack() {
    this.location.back()

  }
  validate(i) {
    const selectedChoice = this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').value
    if (selectedChoice && selectedChoice.id === 'Q1') {
      if (selectedChoice && selectedChoice.choice === true) {
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').reset()
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').disable()
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').setValidators([])
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').updateValueAndValidity()

      } else {
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').enable()
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').setValidators([Validators.required])
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').updateValueAndValidity()

      }
    } else if (selectedChoice && selectedChoice.id === 'Q3') {
      if (selectedChoice && selectedChoice.choice === true) {
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').reset()
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').disable()
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').setValidators([])
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').updateValueAndValidity()

      } else {
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').enable()
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').setValidators([Validators.required])
        this.tpFeedbackForm.get('feedbacks')['controls'][i + 1].get('feedback').get('choice').updateValueAndValidity()

      }
    }
  }

  showInputs(i) {
    const selectedChoice = this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').value
    if (selectedChoice && selectedChoice.choice === 'Others') {
      this.othersInput = true;
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').setValidators([Validators.required])
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').updateValueAndValidity()

    } else {
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').reset()
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').setValidators()
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').updateValueAndValidity()
      this.othersInput = false;
    }
  }
  otherInputQFour(i) {
    const selectedChoice = this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').value
    if (selectedChoice && selectedChoice.choice === 'Others') {
      this.QFourInput = true;
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').setValidators([Validators.required])
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').updateValueAndValidity()
    } else {
      this.QFourInput = false;
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').reset()
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').setValidators()
      this.tpFeedbackForm.get('feedbacks')['controls'][i].get('feedback').get('others').updateValueAndValidity()
    }
  }

  reset() {
    this.tpFeedbackForm.reset();
  }
}
